import { render, staticRenderFns } from "./GroupChat.vue?vue&type=template&id=107235fb&scoped=true"
import script from "./GroupChat.vue?vue&type=script&lang=js"
export * from "./GroupChat.vue?vue&type=script&lang=js"
import style0 from "./GroupChat.vue?vue&type=style&index=0&id=107235fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107235fb",
  null
  
)

export default component.exports